import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { Button, Input } from 'antd';

import { JitsiMeet } from '../../components/JitsiMeet/JitsiMeet';
import Spinner from '../../components/Spinner/Spinner';

import useMedia from './useMedia';

import { LocationState } from './Media.model';

import styles from './Media.module.scss';
import CreateVideoFeedback from '../../components/CreateVideoFeedback/CreateVideoFeedback';

export const Media = () => {
	const location = useLocation<LocationState>(); // Get state params
	const { isInitiator } = location.state || { isInitiator: false };
	const params: any = new URLSearchParams(location.search); // Get query params

	const {
		isOrganizer,
		navigate,
		onMeetingEnd,
		onMeetingStart,
		onRecordingStatusChange,
		onParticipantsNrChange,
		state: {
			hasRecordings,
			jwt,
			loading,
			onCall,
			organizer,
			roomName,
			showPopup
		},
		togglePopup
	} = useMedia({
		initialMeetUrl: params.get('meetUrl'),
		isInitiator
	});

	return (
		<div className={styles.pageContainer}>

			<div className={`${styles.pageSider}`}>
				<div className={styles.siderContent}>

				</div>
			</div>

			<div className={styles.pageContent}>
				<div className={styles.content}>
					<Spinner delay={0} spinning={loading} />
					{onCall && roomName && jwt &&
						<JitsiMeet
							containerStyles={{ height: '100%', width: '100%' }}
							roomName={roomName}
							jwt={jwt}
							userInfo={{ displayName: 'Ema' }}
							onMeetingStart={onMeetingStart}
							onMeetingEnd={onMeetingEnd}
							onRecordingStatusChange={onRecordingStatusChange}
							onParticipantsNrChange={onParticipantsNrChange}
							organizerId={organizer}
						/>
					}
				</div>
			</div>
			{showPopup && <CreateVideoFeedback onClose={togglePopup} isOrganizer={isOrganizer() && hasRecordings} />}
		</div>
	);
}

export default Media;
